import React from "react"
import ModalComponent from "../../components/Modal"
import { Card, Col, Row, Table } from "react-bootstrap"
import moment from "moment"

const BookingDetails = ({ show, handleClose, isView }) => {
  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"xl"}
        modeltitle={isView.id}
        btnclosetext={"Close"}
        onHide={handleClose}
        backdrop="static"
        children={
          <>
            {isView?.cancellation_reason && (
              <div class="alert alert-danger py-2" role="alert">
                {isView?.cancellation_reason}
              </div>
            )}

            <div className="userperson_details_wrapper mb-3 ctmcard_shadow">
              <Row xs="auto" className="m-0 gap-2">
                <Col className="p-0">
                  <div className="userprofile">
                    {isView?.user?.profile_img ? (
                      <img
                        src={
                          isView?.user?.profile_img?.startsWith("/")
                            ? process.env.REACT_APP_RESOURCE_URL +
                              isView?.user?.profile_img
                            : isView?.user?.profile_img
                        }
                        alt="UserImage"
                        className="uravtar_img"
                      />
                    ) : (
                      <i
                        className="avtar_nm"
                        data-name={
                          isView?.user?.name
                            ? isView?.user?.name
                                ?.split(" ")
                                .map((word) => word.charAt(0).toUpperCase())
                                .join("")
                            : "-"
                        }
                      ></i>
                    )}
                    <div className="user_nmem">
                      <h2 className="nmtitle_user">{isView?.user?.name}</h2>
                      <p className="user_phonmail d-flex align-items-center gap-1">
                        <i className="icon_main phone_icon"></i>+91{" "}
                        {isView?.user?.phone}
                      </p>
                      <p className="user_phonmail d-flex align-items-center gap-1">
                        <i className="icon_main email_icon"></i>
                        {isView?.user?.email}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ms-md-auto p-0">
                  <div className="numberdetail_charging">
                    <p>Vehicle Name</p>
                    <span>
                      {isView?.fleet_vehicle
                        ? `${isView.fleet_vehicle?.brand?.brand_name || ""} ${
                            isView.fleet_vehicle.registration_number
                          } - ${isView.fleet_vehicle.model}`
                        : `${isView?.vehicles_catalogue?.brand?.brand_name || ""} ${
                            isView?.vehicles_catalogue?.model || ""
                          }`}
                    </span>
                  </div>
                </Col>
                <Col className="p-0">
                  <div className="numberdetail_charging">
                    <p>Consumption(W)</p>
                    <span>{isView?.consumption || "0"}</span>
                  </div>
                </Col>
                <Col className="p-0">
                  <div className="numberdetail_charging">
                    <p>Payment method</p>
                    <span>
                      {isView?.bookingwise_payment?.payment_method || "-"}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>

            <Card className="mb-3">
              <Card.Body>
                <Table
                  className="rounded mb-0 table-striped overflow-x-auto"
                  responsive
                >
                  <thead>
                    <tr>
                      <th>Serial Number</th>
                      <th>Station Name</th>
                      <th className="text-center">Connector / Position</th>
                      <th className="text-center">Slot Time</th>
                      <th className="text-center">Booking Time</th>
                      {isView?.status === "Completed" && (
                        <th className="text-center">Session</th>
                      )}
                      {isView?.status === "Cancelled" && (
                        <th className="text-center">Cancelled Time</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{isView?.charger?.id}</td>
                      <td>{isView?.station?.station_name}</td>
                      <td className="text-center">
                        <span className="mb-0 text-uppercase">
                          {isView?.connector?.connector_type}
                        </span>
                        <p className="mb-0 text_7gray lh-1">
                          {isView?.charger_position}
                        </p>
                      </td>
                      <td className="text-center">
                        {moment(
                          isView?.booked_start_time?.split(" ")[1],
                          "HH:mm:ss",
                        ).format("hh:mm A")}{" "}
                        -{" "}
                        {moment(
                          isView?.booked_end_time?.split(" ")[1],
                          "HH:mm:ss",
                        ).format("hh:mm A")}
                      </td>
                      <td className="text-center">
                        <p className="mb-0 text_7gray lh-1">
                          {moment(isView?.booked_start_time).format(
                            "YYYY-MM-DD",
                          )}
                        </p>
                        <span className="mb-0 text-uppercase fw-semibold">
                          {moment(isView?.createdAt).format("hh:mm A")}
                        </span>
                      </td>
                      {isView?.status === "Completed" && (
                        <td className="text-center">
                          {moment(
                            isView?.session_start_time.split(" ")[1],
                            "HH:mm:ss",
                          ).format("hh:mm A")}{" "}
                          -{" "}
                          {moment(
                            isView?.session_end_time.split(" ")[1],
                            "HH:mm:ss",
                          ).format("hh:mm A")}
                        </td>
                      )}
                      {isView?.status === "Cancelled" && (
                        <td className="text-center">
                          <p className="mb-0 text_7gray lh-1">
                            {moment(isView?.updatedAt)
                              .local()
                              .format("YYYY-MM-DD")}
                          </p>
                          <p className="mb-0 text-uppercase fw-semibold">
                            {moment(isView?.updatedAt)
                              .local()
                              .format("hh:mm A")}
                          </p>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body>
                <Table
                  className="rounded mb-0 table-striped overflow-x-auto"
                  responsive
                >
                  <thead>
                    <tr>
                      <th>Price details</th>
                      <th className="text-end">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Base Price (Slot) </td>
                      <td className="text-end">
                        ₹{isView?.bookingwise_payment?.base_fee || 0}/-
                      </td>
                    </tr>
                    <tr>
                      <td>Parking fee</td>
                      <td className="text-end">
                        ₹{isView?.bookingwise_payment?.parking_fee || 0}/-
                      </td>
                    </tr>
                    <tr>
                      <td>Convenience fee</td>
                      <td className="text-end">
                        ₹{isView?.bookingwise_payment?.convenience_fee || 0}/-
                      </td>
                    </tr>
                    <tr>
                      <td>GST ({isView?.bookingwise_payment?.gst || 0}%)</td>
                      <td className="text-end">
                        ₹{isView?.bookingwise_payment?.gst_amount || 0}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Total Amount</td>
                      <td className="text-end fw-semibold">
                        ₹{isView?.bookingwise_payment?.amount || 0}/-
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </>
        }
      />
    </>
  )
}

export default BookingDetails
